import { ProfileLogoInput, TenantProfile } from '@services';
import { useStore } from '@stores';
import { observer } from 'mobx-react';
import React, { useCallback, useState } from 'react';
import Presentation from './GarageDetailsHeader.presentation';

interface IProps {
  tenantProfile: TenantProfile;
}

export const GarageDetailsHeader: React.FC<IProps> = observer(({ tenantProfile }) => {
  const { tenantProfileStore } = useStore();
  const [visible, setVisible] = useState(false);

  const handleLogoUpdate = useCallback(
    async (profileLogo: ProfileLogoInput) => await tenantProfileStore.updateLogo(profileLogo),
    [tenantProfileStore]
  );

  const handleLogoDelete = useCallback(
    async () => await tenantProfileStore.deleteLogo(),
    [tenantProfileStore]
  );

  const handleActiveChange = useCallback(
    async (id: number) => await tenantProfileStore.changeActive(id),
    [tenantProfileStore]
  );

  return (
    <Presentation
      tenantProfile={tenantProfile}
      visible={visible}
      setVisible={setVisible}
      handleLogoUpdate={handleLogoUpdate}
      handleLogoDelete={handleLogoDelete}
      handleActiveChange={handleActiveChange}
    />
  );
});
